// extracted by mini-css-extract-plugin
export var card = "_mx-1";
export var summary = "_mx-0";
export var unreadDot = "_mx-2";